import React from 'react';
import './styles.css';
import { FaArrowUp } from 'react-icons/fa'

interface TypeProps {
  title: string,
  value: string,
  percentual: string,
  info: string,
}

export default function WidgetCard({ title, value, percentual, info }: TypeProps) {
  return (
    <div id='container-widget-card'>
      <h1>{title}</h1>
      <div id="widget-card-result">
        <span id="widget-card-result-value">{value}</span>
        <span id="widget-card-result-percentual">{percentual}<FaArrowUp color='#92929D' fontSize='12' /></span>
      </div>
      <span id="widget-card-result-info">{info}</span>
    </div>
  )
}
